<div class="header">
    <div class="row m-t-5">
        <div class="col-sm text-center" style="padding: 0 11px" *ngFor="let topButton of headerMenus">
            <a>
                <img [src]="topButton.icon"/>
                <label>{{topButton.title}}</label>
            </a>
        </div>
    </div>
</div>